const prefersReducedMotion = () => typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
export const scrollToSearchTopTarget = target => {
  if (!(target != null && target.dataHook)) {
    return;
  }
  const element = document.querySelector(`[data-hook="${target.dataHook}"]`);
  if (!element) {
    return;
  }
  if (target.scrollMarginTop !== undefined) {
    element.style.scrollMarginTop = target.scrollMarginTop;
  }
  element.scrollIntoView({
    behavior: prefersReducedMotion() ? 'auto' : 'smooth',
    block: 'start'
  });
};
//# sourceMappingURL=scrollToSearchTopTarget.js.map